export default {
	state: {
		grafanaSettings: {},
		grafanaAvailableSensors: [],
		grafanaSettingsFullLoad: false,
	},
	actions: {
		fetchGrafanaSettings({dispatch, commit, getters}) {
			return new Promise((resolve, reject) => {
				if (!getters.getApiToken) {
					return reject(false)
				}
				dispatch('setLastCall', {name: 'fetchUnitsTypes', time: Date.now() / 1000})

				this.$api.grafana.grafanaSettings()
					.then((response) => {
						if (response.status < 400 && !response.data?.error) {
							commit('updateGrafanaSettings', response.data)
							commit('setGrafanaSettingsFullLoad', true)
							resolve(response.data)
						} else {
							reject(response)
						}
					})
					.catch((error) => {
						reject(error)
						console.error(error);
					})
					.finally(() => {
						dispatch('setLastCall', {name: 'fetchUnitsTypes', inprogress: false})
					});
			})
		},
	},
	mutations: {
		updateGrafanaSettings(state, grafanaSettings) {
			state.grafanaSettings = grafanaSettings
		},
		setGrafanaSettingsFullLoad(state, FullLoad) {
			state.grafanaSettingsFullLoad = state.grafanaSettingsFullLoad || FullLoad
		},
	},
	getters: {
		getGrafanaSettingsFullLoad(state) {
			return state.grafanaSettingsFullLoad
		},
		getGrafanaPanelByColor(state) {
			return state.grafanaSettings['panels']
		},
		getGrafanaDashboardUrl(state) {
			return state.grafanaSettings['dashboardUrl']
		},
		getGrafanaDefaultSensors(state) {
			return state.grafanaSettings['defaultSensors']
		}
	},
}